import { ProductFieldStatus } from "./product-field-status.type";
import { ProductStatusIndicatorTooltipManual } from "../components/product-status-indicator-tooltip-manual/product-status-indicator-tooltip-manual.component";
import { ProductStatusIndicatorTooltipOverwritten } from "../components/product-status-indicator-tooltip-overwritten/product-status-indicator-tooltip-overwritten.component";
import { ProductStatusIndicatorTooltipConfirmed } from "../components/product-status-indicator-tooltip-confirmed/product-status-indicator-tooltip-confirmed.component";
import { withShowIf } from "../../../../../components/with-show-if/with-show-If.component";
import { ProductStatusIndicatorTooltipRemoved } from "../components/product-status-indicator-tooltip-removed/product-status-indicator-tooltip-removed.component";

const TooltipComponents = [
  { status: "manual", component: ProductStatusIndicatorTooltipManual },
  { status: "system_overwritten", component: ProductStatusIndicatorTooltipOverwritten },
  { status: "system_confirmed", component: ProductStatusIndicatorTooltipConfirmed },
  { status: "removed", component: ProductStatusIndicatorTooltipRemoved },
];

export const getStatusIndicatorTooltip = (status: ProductFieldStatus) =>
  TooltipComponents.find((option) => option.status === status)?.component || withShowIf(() => null);
